import { createPostEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type PostSendInvitationLinkRequest = {
	userId: number;
	shardName?: string;
};

export const postSendInvitationLink = createPostEndpoint<PostSendInvitationLinkRequest, void>(
	(request) => `/api/v3/core/users/${request?.userId}/links/invitation/send`,
	{
		headers: (request) => {
			if (request?.shardName) {
				return { [ HttpHeader.Shard ]: request.shardName };
			}

			return {};
		},
		skipAuthRefresh: true
	}
);
